<template>
  <div class="apresentacoes-view">
    <v-container align-center justify-center class="container">
      <Card
        title="Inventário">
        <div v-if="listaobjetos.length > 0">
          <ItemInventario v-for="obj in listaobjetos" v-bind:key="obj.codigo" v-bind:obj="obj"></ItemInventario>
        </div>
      </Card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import ItemInventario from '@/components/ItemInventario.vue'
import Card from '@/components/Card.vue'
import { db } from '../main'

function compararNome (a, b) {
  if (a.nome > b.nome) return 1
  if (a.nome < b.nome) return -1
  return 0
}

function compararDataInicio (a, b) {
  if (!a.inicio || !b.inicio || new Date(a.inicio.seconds * 1000) > new Date(b.inicio.seconds * 1000)) return 1
  if (new Date(a.inicio.seconds * 1000) < new Date(b.inicio.seconds * 1000)) return -1
  return 0
}

function compararDataLocal (a, b) {
  if (!a.data || !b.data || new Date(a.data.seconds * 1000) > new Date(b.data.seconds * 1000)) return 1
  if (new Date(a.data.seconds * 1000) < new Date(b.data.seconds * 1000)) return -1
  return 0
}

function compararStatus (a, b) {
  console.log(a)
  if (b.status === 'desativado') return -1
  return 0
}

function computarStatus (obj) {
  if (!obj.ativo) {
    return 'desativado'
  }
  const dataAtual = new Date()
  const lastCheck = new Date(obj.local[obj.local.length - 1].data.seconds * 1000)
  const usos = []
  for (let i = 0; i < obj.usos.length; i++) {
    usos.push(obj.usos[i])
  }
  usos.sort(compararDataInicio)
  // Vetor usos está sortado por data de inicio
  for (let i = 0; i < usos.length; i++) {
    if (dataAtual > new Date(usos[i].inicio.seconds * 1000) && dataAtual < new Date(usos[i].termino.seconds * 1000)) {
      return 'em uso'
    }
    if (i < usos.length - 1 && dataAtual > new Date(usos[i].termino.seconds * 1000) && dataAtual < new Date(usos[i + 1].inicio.seconds * 1000)) {
      if (lastCheck < new Date(usos[i].termino.seconds * 1000)) {
        return 'requer verificacao e uso agendado'
      } else {
        return 'uso agendado'
      }
    }
    if (usos.length === 1 && dataAtual < new Date(usos[i].inicio.seconds * 1000)) {
      return 'uso agendado'
    }
    if (i === usos.length - 1 && dataAtual > new Date(usos[i].termino.seconds * 1000) && lastCheck < new Date(usos[i].termino.seconds * 1000)) {
      return 'requer verificacao'
    }
  }
  return 'situacao regular'
}

export default {
  name: 'inventario',
  components: {
    ItemInventario,
    Card
  },
  data () {
    return {
      objetos: []
    }
  },
  computed: {
    listaobjetos: function () {
      const objetos = []
      for (let i = 0; i < this.objetos.length; i++) {
        const obj = this.objetos[i]
        console.log(obj.nome)
        console.log(computarStatus(obj))
        obj.status = computarStatus(obj)
        obj.local = obj.local.sort(compararDataLocal)
        objetos.push(obj)
      }
      return objetos.sort(compararNome).sort(compararStatus)
    }
  },
  mounted () {
    this.$bind('objetos', db.collection('inventario'))
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}

h1 {
  font-size: 2rem;
  margin-top: 5px;
}

.main-wrapper {
  margin: auto;
  margin-top: 20px;
  padding-top: 10px;
  padding: 16px;
  color: black;
  background-color: #FFFFFF;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.inventario-section {
  margin-bottom: 30px;
}

  /* Mobile Styles */
@media only screen and (max-width: 415px) {
  .main-wrapper {
    width: 100%;
    margin-top: 0px;
  }
}

/* iphone XR */
@media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  .main-wrapper {
    width: 100%;
    margin-top: 0px;
  }
}

/* Desktop Styles */
@media only screen and (min-width: 416px) {
  .main-wrapper {
    max-width: 50%;
    -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    border-radius:6px;
    -moz-border-radius:6px;
    -webkit-border-radius:6px;
  }
}
</style>
